import { Accordion, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import surface from './KensukeSurface.module.scss';

const FAQ_ITEMS = [1, 2, 3, 4, 5] as const;

export default function KensukeSeoFaq() {
  const { t } = useTranslation();

  return (
    <section id="faq" className={surface.section} aria-labelledby="home-faq-heading">
      <Container>
        <h2 id="home-faq-heading" className={surface.sectionHeading}>
          {t('home.seo_faq_title', { defaultValue: 'よくある質問' })}
        </h2>
        <p className={surface.sectionLead}>
          {t('home.seo_faq_subtitle', {
            defaultValue: '検索・引用向けに、プロジェクトの要点をまとめています。',
          })}
        </p>
        <Accordion flush className={`${surface.requestsCard} ${surface.clipRound}`}>
          {FAQ_ITEMS.map((n) => (
            <Accordion.Item eventKey={String(n)} key={n}>
              <Accordion.Header as="h3">{t(`home.seo_faq_q${n}`)}</Accordion.Header>
              <Accordion.Body>{t(`home.seo_faq_a${n}`)}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
}
